export default function Powitanie() {
    const kolory = ["blue", "red", "green"];
    const tlo = kolory[Math.floor(Math.random() * kolory.length)];

    const quequ = [
        "Fun fact: Creeper powstał przez przypadek!",
        "Najlepszy build w grze zależy tylko od Ciebie.",
        "Gry to świetny sposób na rozwój kreatywności."
    ];

    const losowo = quequ[Math.floor(Math.random() * quequ.length)];

    return (
        <div
            className="text-white text-center py-5 mb-4 shadow rounded"
            style={{
                background: `linear-gradient(135deg, ${tlo}, black)`
            }}
        >
            <h1 className="display-5 fw-bold">Portal o grach komputerowych</h1>
            <h2 className="fs-4 mt-3">{losowo}</h2>
        </div>
    );
}
